import React, { useRef, useState } from 'react';
import './styles.css';
import { useNavigate } from 'react-router-dom';
import { Button, Grid, TextField, Typography } from '@mui/material';
import { fetchPost } from '../../api/common';
import { Profile } from '@par/shared/types/player';

type PropTypes = {
  setProfile: (profile: Profile) => void;
};

export const SignUp = ({ setProfile }: PropTypes) => {
  // const inviteCodeRef = useRef<HTMLInputElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);
  const passwordConfirmRef = useRef<HTMLInputElement>(null);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailVerificationSent, setEmailVerificationSent] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event: any) => {
    //Prevent page reload
    event.preventDefault();

    // if (!inviteCodeRef.current) {
    //   return setError('You need an invite code to join');
    // }

    if (
      // !inviteCodeRef.current ||
      !emailRef.current ||
      !passwordRef.current ||
      !passwordConfirmRef.current
    ) {
      return setError('Fill in all fields');
    }

    if (passwordRef.current.value.length < 8) {
      return setError('Password must be at least 8 characters');
    }

    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      return setError('Passwords do not match');
    }

    try {
      setError('');
      setLoading(true);
      const res = await fetchPost('/authenticate/register', {
        // inviteCode: inviteCodeRef.current.value,
        email: emailRef.current.value,
        password: passwordRef.current.value,
      });
      if (res) {
        setMessage('Email verification sent. Please check your email.');
        setEmailVerificationSent(true);
      }
    } catch (e: any) {
      if (e instanceof Response) {
        const errRes = await e.json();
        if (errRes.message === 'Invite code not found') {
          setError('Invite code already used or is invalid');
          setLoading(false);
          return;
        }
        if (errRes.message === 'Email already registered') {
          setError('This email has already been registered');
          setLoading(false);
          return;
        }
      } else {
        setError('Failed to create account');
      }
    }

    setLoading(false);
  };

  const renderErrorMessage = () => (
    <Typography color="error.main">{error}</Typography>
  );

  const renderMessage = () => (
    <Typography color="success.main">{message}</Typography>
  );

  return (
    <>
      <Grid item>{renderErrorMessage()}</Grid>
      <Grid item>{renderMessage()}</Grid>
      <Grid item>
        <Typography component="h1" variant="h5" sx={{ marginBottom: '24px' }}>
          Sign up
        </Typography>
      </Grid>
      <Grid item>
        <form onSubmit={handleSubmit}>
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <TextField
                type="email"
                placeholder="Email"
                fullWidth
                variant="outlined"
                name="username"
                inputRef={emailRef}
                required
                disabled={emailVerificationSent}
              />
            </Grid>
            <Grid item>
              <TextField
                type="password"
                placeholder="Password"
                fullWidth
                variant="outlined"
                name="password"
                inputRef={passwordRef}
                required
                disabled={emailVerificationSent}
              />
            </Grid>
            <Grid item>
              <TextField
                type="password"
                placeholder="Confirm Password"
                fullWidth
                variant="outlined"
                name="password-confirm"
                inputRef={passwordConfirmRef}
                required
                disabled={emailVerificationSent}
              />
            </Grid>
            <Grid item>
              {!loading ? (
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  className="button-block"
                  disabled={emailVerificationSent}
                >
                  {emailVerificationSent ? 'Email sent' : 'Sign up'}
                </Button>
              ) : null}
            </Grid>
          </Grid>
        </form>
      </Grid>
    </>
  );
};
